import { addDoc, collection, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { app } from '../../util/firebase';

const CommandesList = (props) => {

    const [listCommandes, setListCommandes ] = useState([])

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"commandesClient"),(snapshot)=>{
            setListCommandes(snapshot.docs.map((snap)=> {
                let commande = snap.data()
                commande.id = snap.id
                return commande
            }))
        })
    },[])
    
    const validCommande=(commande)=>{
        
        let notif = {
            title: 'Karangué Assurance',
            message:'Nous avons accepté votre commande de '+commande.name_commande,
            clientId:"undifined",
            isClientReaded:false,
            isCPharmacieReaded:false
        }

        addDoc(collection(getFirestore(app),"notifications"),notif)
        .then(res=>{
            commande.isValid = true
            setDoc(doc(getFirestore(app),"commandesClient",commande.id),commande)
            .catch(err=>alert(err))
        })
        .catch(err=>alert(err))
    }
    const archiveCommande=(commande)=>{
        commande.isArchived = true
        setDoc(doc(getFirestore(app),"commandesClient",commande.id),commande)
        .then(res=>alert('Commande archivé'))
        .catch(err=>alert(err))
    }
    const recoverCommande=(commande)=>{
        commande.isArchived = false
        setDoc(doc(getFirestore(app),"commandesClient",commande.id),commande)
        .then(res=>alert('Commande récupèré'))
        .catch(err=>alert(err))
    }
    const allCommandes = ()=>{
        let list = []
        if(props.isValid===null){
            list = listCommandes.filter(commande=> commande.isArchived=== props.isArchived)
        }else{ 
            list = listCommandes.filter(commande=> commande.isValid === props.isValid && commande.isArchived=== props.isArchived)
        }
        return list.map((commande,index)=>{
            return(
                <tr key={index}>
                    <td><img style={{maxHeight:'40px'}} className="product-img" src={commande.imgSrc_commande}  alt="" /></td>
                    <td>{commande.name_commande}</td>
                    <td>{commande.price_commande}</td>
                    <td>{commande.user.userName}</td>
                    <td>{commande.user.email}</td>                   
                    {commande.isArchived?
                        <td>
                            <button className="btn btn-warning" onClick={e=>recoverCommande(commande)}>Récuperer</button>
                        </td>
                        :
                        <td>
                            {commande.isValid?
                                <button className="btn btn-success mx-2 disabeled">Validé</button> 
                                :
                                <button className="btn btn-primary mx-2" onClick={e=>validCommande(commande)}>Valider</button> 
                            }
                            <button className="btn btn-warning" onClick={e=>archiveCommande(commande)}>Archiver</button>
                        </td>
                    }
                </tr>
            )
        })
    }
    return (
        <div>
            <div className="col-12 bg-light p-3">
                <table className="table table-striped table-hover border rounded">
                    <thead>
                        <tr className='bg-white '>
                            <td>Image </td>
                            <td>Nom Complet </td>
                            <td>Prix en FCFA </td>
                            <td>User Name </td>
                            <td>Email </td>
                            <td>Action </td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            allCommandes()
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CommandesList;